export default "__VITE_ASSET__b2e5cb39__"